<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBaseMaster from '../TableRowBase.vue';

  export default {
    name: 'TableRowBase',
    extends: TableRowBaseMaster,
    props: {
      title: {
        default: null,
      }
    },
    computed: {
      displayTitle() {
        return this.title || 'Annually';
      },
      low_value_annually() {
        return this.formatData(this.benchmark.low_value_monthly * 12);
      },
      median_value_annually() {
        return this.formatData(this.benchmark.median_value_monthly * 12);
      },
      high_value_annually() {
        return this.formatData(this.benchmark.high_value_monthly * 12);
      },
      previousYtdAnnually() {
        return this.formatData(this.previousYtdRaw * 12);
      },
      actualYtdAnnually() {
        return this.formatData(this.actualYtdAnnuallyRaw );
      },
      actualYtdAnnuallyRaw() {
        return this.actualYtdRaw * 12;
      },
      benchmarkDiffRaw() {
        return this.actualYtdAnnuallyRaw - (this.benchmark.median_value_monthly * 12);
      },
      benchmarkDiffAnnuallyDisplay() {
        return this.getValueDiff(this.benchmarkDiffRaw, (this.benchmark.median_value_monthly * 12));
      },
    },
  };
</script>
